export enum ERegisterResult {    
    Failed,
    Success
}